'use strict';
import isObject from 'lodash/isObject';
import {getDomainLink} from '../../core-utilities/domain/ReduxUtils';
import {toStringStatic} from '../../assets/domain/AssetDomain';


export const ASSET_PROJECT_CLASS_NAME = 'AssetProjectDomain';
export const ASSET_PROJECT_COLLECTION = 'asset-projects';

export function AssetProjectDomainProvider() {
  return {
    $get: [
      'AbstractDomainClass',
      'MetricMixin',
      'OrgIdMixin',
      'FeedableMixin',
      'restUtils',
      function (AbstractDomainClass, MetricMixin, OrgIdMixin, FeedableMixin, restUtils) {

        function AssetProjectDomain(data) {
          AbstractDomainClass.call(this, AssetProjectDomain, data);
        }

        AbstractDomainClass.__inheritFrom(AssetProjectDomain, ASSET_PROJECT_CLASS_NAME, ASSET_PROJECT_COLLECTION);
        OrgIdMixin(AssetProjectDomain);
        MetricMixin(AssetProjectDomain);
        FeedableMixin(AssetProjectDomain);

        AssetProjectDomain.$constraints.addConstraints({
          asset: {type: 'Domain', domainClass: 'AssetDomain'},
          project: {type: 'Domain', domainClass: 'ProjectDomain'},
          status: {
            type: 'string',
            inList: ['cancelled', 'pending', 'in_progress', 'has_rejections', 'complete'],
            defaultValue: 'pending'
          },
          completedOn: {type: 'Date', immutable: true, nullable: true},
          completedBy: {type: 'string', immutable: true, nullable: true},
          cancelledOn: {type: 'Date', immutable: true, nullable: true},
          cancelledBy: {type: 'string', immutable: true, nullable: true},
          org: {type: 'string'}, // Organization ID
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain', nullable: true},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'},

          conversation: {type: 'LinkedDocument', domainClass: 'ConversationDomain', link: 'target'},

          members: {type: 'DomainCollection', domainClass: 'UserDomain', links: 'asset-projects'},
          assetTasks: {type: 'DomainCollection', domainClass: 'AssetTaskDomain', link: 'assetProject', belongsTo: true},
          privateAssetTasks: {
            type: 'DomainCollection',
            domainClass: 'AssetTaskDomain',
            link: 'assetProject',
            belongsTo: true
          }
        });

        // for fallback API methods
        AssetProjectDomain.fallbackIdProperty = 'projectId';
        AssetProjectDomain.updateStatusFallbackMethod = 'asset-projects/status/update';


        // more methods go here;

        AssetProjectDomain.updateStatus = restUtils.updateStatus(AssetProjectDomain);
        AssetProjectDomain.prototype.updateStatus = restUtils.updateStatusProto(AssetProjectDomain);

        AssetProjectDomain.prototype.getProjectName = function () {
          return isObject(this.project) && this.project.name;
        };

        AssetProjectDomain.prototype.getFullName = function () {
          return Promise.props({
            project: getDomainLink(this, 'project'),
            asset: getDomainLink(this, 'asset'),
          }).then(data => getFullName(data.project, data.asset));
        };

        AssetProjectDomain.prototype.getFullNameSync = function () {
          return getFullName(this.project, this.asset, void 0);
        };

        AssetProjectDomain.prototype.toString = function () {
          return this.asset && isObject(this.asset) ? this.asset.toString() : '';
        };

        return AssetProjectDomain;
      }]
  };
}

/**
 * Get the asset project name from the parent project and asset.
 * @param {Object} project The project data instance
 * @param {Object} asset The asset data instance
 * @param {?String} [fallback='project']
 * @returns {String}
 */
export function getFullName(project, asset) {
  const fallback = arguments.length > 2 ? arguments[2] : 'project';
  return project && asset ? project.name + ' | ' + toStringStatic(asset) : fallback;
}



// WEBPACK FOOTER //
// ./src/js/projects/domain/AssetProjectDomain.js